import { ConsoleLogger } from "aws-amplify/utils";

type LogType = "error" | "info" | "warn" | "debug";

export const logMessage = (
  screenName: string,
  message: string,
  type: LogType,
): void => {
  const logger = new ConsoleLogger(screenName);
  switch (type) {
    case "error": {
      logger.error(`${message}`);
      break;
    }
    case "info": {
      logger.info(`${message}`);
      break;
    }
    case "warn": {
      logger.warn(`${message}`);
      break;
    }
    case "debug": {
      logger.debug(`${message}`);
      break;
    }
    default: {
      logger.info(`${message}`);
      break;
    }
  }
};
